// extracted by mini-css-extract-plugin
export default {"container":"select-multiple_container__PzgSV"};